import React from "react";
import { useLocation } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useUserInfo } from "../../utils/user";
import { isCoachTrialExemptPath } from "../../utils/coachTrialPaths";
import CoachSubscriptionModal from "./CoachSubscriptionModal";

const PLATFORM_OWNER_USER_ID = import.meta.env.VITE_PLATFORM_OWNER_USER_ID;
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY);

const appearance = {
  theme: "stripe",
  variables: {
    colorPrimary: "#ff0000",
    fontFamily: "Roboto Mono, monospace",
  },
};

/**
 * After a coach's free trial ends, require subscription on app routes
 * (not marketing/auth/coach-subscription pages).
 */
const CoachTrialExpiredGate = () => {
  const location = useLocation();
  const { loading, isCoach, id, stripeCustomerId, coachSubscription } =
    useUserInfo();

  if (
    loading ||
    !isCoach ||
    id === PLATFORM_OWNER_USER_ID ||
    isCoachTrialExemptPath(location.pathname)
  ) {
    return null;
  }

  const sub = coachSubscription;
  if (!sub || sub?.error || sub?.hasSubscription || !sub?.freeTrialExpired) {
    return null;
  }

  const handleSuccess = () => {
    localStorage.removeItem("userInfo");
    window.location.reload();
  };

  return (
    <Elements
      stripe={stripePromise}
      options={{
        appearance,
        fonts: [
          {
            family: "Roboto Mono, monospace",
            cssSrc:
              "https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@100;400;500;700",
          },
        ],
      }}
    >
      <CoachSubscriptionModal
        open
        disableClose
        dialogTitle="Your free trial has ended"
        leadIn="Subscribe to keep using Trainer App with your clients."
        existingStripeCustomerId={stripeCustomerId}
        submitLabel="Subscribe to continue"
        onSuccess={handleSuccess}
      />
    </Elements>
  );
};

export default CoachTrialExpiredGate;
